import { CONSTANTS } from '@pk/powerkioskutils';
import { AgentEmailPreferenceSetting } from './agent-email-preference-setting';
import { EmailSection } from './email-section';
import { EmailSectionGroup } from './email-section-group';
import { RfqSessionNudgeSetting } from './rfq-session-nudge-setting';
import { Role } from './role';

export class UserNotificationCategory {
	public id: number;
	public name: string;
	public description: string;
	public userNotificationCategoryTypeId: number;
	public userNotificationCategorySetId: number;
	public userNotificationCategoryGroupId: number;
	public userNotificationCategoryCampaignId: number;
	public userNotificationCategoryCollectionId: number;
	public sortOrder: number;
	public isAdminOnly: boolean;
	public isUSOnly: boolean;
	public isMandatory: boolean;
	public isParentOnly: boolean;
	public isAffectedByIsPaidIndividually: boolean;
	public thImgPath: string;
	public fullImgPath: string;

	public rfqSessionNudgeSettings: RfqSessionNudgeSetting[];
	public agentEmailPreferenceSetting: AgentEmailPreferenceSetting;
	public emailSections: EmailSection[];
	public roles: Role[];

	// internal grouping
	public emailSectionGroups?: EmailSectionGroup[];

	constructor(userNotificationCategory?: UserNotificationCategory) {
		Object.assign(this, userNotificationCategory);

		this.agentEmailPreferenceSetting = this.agentEmailPreferenceSetting
			? new AgentEmailPreferenceSetting(this.agentEmailPreferenceSetting)
			: this.agentEmailPreferenceSetting;
		this.emailSections = this.emailSections ? this.emailSections.map(es => new EmailSection(es)) : this.emailSections;
	}

	get isBrokerLevel() {
		return (
			this.roles.some(r => [CONSTANTS.userRoles.salesManager.roleId].includes(r.roleId)) &&
			this.roles.some(r => [CONSTANTS.userRoles.sales.roleId].includes(r.roleId)) &&
			!this.roles.some(r => [CONSTANTS.userRoles.customer.roleId].includes(r.roleId))
		);
	}

	get isCustomerLevel() {
		return (
			this.roles.some(r => [CONSTANTS.userRoles.salesManager.roleId].includes(r.roleId)) &&
			this.roles.some(r => [CONSTANTS.userRoles.sales.roleId].includes(r.roleId)) &&
			this.roles.some(r => [CONSTANTS.userRoles.customer.roleId].includes(r.roleId))
		);
	}

	get isLeadLevel() {
		return this.roles.every(r => [CONSTANTS.userRoles.lead.roleId].includes(r.roleId));
	}

	get isEnterpriseLevel() {
		return this.roles.every(r => [CONSTANTS.userRoles.enterprise.roleId].includes(r.roleId));
	}
}
